/* getLoginFormInputs.ts */

/* Ionic */
import { key, person } from "ionicons/icons";

/* Interfaces */
import { BaseLoginProps } from "src/shared/interfaces/api/Login";
import { FormInputProps } from "src/shared/interfaces/common/FormInput";

export const getLoginFormInputs = (
  credentials: BaseLoginProps
): FormInputProps[] => [
  {
    testId: "usernameEmail",
    name: "usernameEmail",
    placeholder: "Username or email",
    type: "text",
    value: credentials.usernameEmail,
    requiredMessage: "Username or email required",
    icon: person,
    validate: (value: string) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const usernameRegex = /^[a-zA-Z0-9_]{3,20}$/;
      if (value.includes("@")) {
        return emailRegex.test(value) || "Email is invalid";
      } else {
        return (
          usernameRegex.test(value) || "Username is invalid"
        );
      }
    },
  },
  {
    testId: "password",
    name: "password",
    placeholder: "Password",
    type: "password",
    value: credentials.password,
    requiredMessage: "Password required",
    icon: key,
  },
];
